<template>
  <omint-page>
    <Header />
    <omint-page-content :message="error">
      <Credential
        v-if="post"
        :id="post.id"
        class="box"
        :idx="-1"
        :number="post.number"
        :name="post.name"
        :ingress="post.ingress"
        :valid="post.valid"
        :birth="post.birth"
        :plan="post.plan"
        :bg="post.bg"
        :credType="post.credType"
        :cns="post.cns"
        :disableToken="true"
        :numberT="post.numberT"
        :planT="post.planT"
        :accT="post.accT"
        :accTp="post.accTp"
        :abrT="post.abrT"
      />
    </omint-page-content>
    <Footer />
  </omint-page>
</template>

<script>
import { mapGetters } from "vuex";
import { ObterCredencialEletronicaCompartilhada } from "@/api/associado";
import Credential from "@/components/Organisms/Credential.vue";
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import { formatDateDDMMYYYY } from "@/utils/formatters";

export default {
  name: "SharedCredential",
  components: { Credential, Header, Footer },
  data() {
    return {
      post: null,
      error: null
    };
  },
  computed: {
    ...mapGetters("saude", ["baseUrl"])
  },
  watch: {
    $route: "fetchData"
  },
  created() {
    this.$root.$emit("show-loading");
    this.fetchData();
  },
  methods: {
    getCredentialType(code) {
      const credentialTypes = {
        P: "prata",
        S: "azul",
        O: "azul"
      };
      return credentialTypes[code] ?? "ouro";
    },
    buildBaseCredential(c, type) {
      return {
        cns: c.NumeroCns,
        birth: formatDateDDMMYYYY(c.DataNascimento),
        ingress: formatDateDDMMYYYY(c.DataIngresso),
        name: c.NomeBeneficiario,
        numberT: null,
        ...type
      };
    },
    buildMedicinaCredential(c) {
      return this.buildBaseCredential(c, {
        id: `med 0`,
        bg: c.CaminhoImagemCredenciaMedicina,
        plan: c.CodigoPlanoMedicina,
        valid: formatDateDDMMYYYY(c.DataFimCredencialMedicina),
        number: c.NumeroCredenciaMedicina,
        credType: this.getCredentialType(c.CodigoCredencialMedicina)
      });
    },
    buildOdontoCredential(c) {
      return this.buildBaseCredential(c, {
        id: `odn 0`,
        bg: c.CaminhoImagemCredenciaOdonto,
        plan: c.CodigoPlanoOdonto,
        valid: formatDateDDMMYYYY(c.DataFimCredencialOdonto),
        number: c.NumeroCredenciaOdonto,
        credType: this.getCredentialType(c.CodigoCredencialOdonto)
      });
    },
    buildTerceiraCredential(c) {
      return this.buildBaseCredential(c, {
        id: `mdsv 0`,
        bg: c.CaminhoImagemCredenciaTerc,
        plan: c.IdPlanoTerceira,
        valid: formatDateDDMMYYYY(c.DataFimCredencialMedicina),
        number: c.NumeroCredenciaMedicina,
        credType: this.getCredentialType(c.CodigoCredencialMedicina),
        numberT: c.NumeroTerceira,
        planT: c.PlanoTerceira,
        accT: c.AcomodacaoTerceira,
        accTp: c.TpAssistencia,
        abrT: c.AbrangenciaTerceira
      });
    },
    setSharedCredential(data) {
      if (data.BeneficiarioPlanoMedicina > 0) {
        this.post = this.buildMedicinaCredential(data);
        return;
      }
      if (data.BeneficiarioPlanoOdonto > 0) {
        this.post = this.buildOdontoCredential(data);
        return;
      }
      if (data.NumeroTerceira !== null) {
        this.post = this.buildTerceiraCredential(data);
      }
    },
    async fetchData() {
      try {
        const sharedUrl = `${this.baseUrl}/shared/`;
        const chave = document.location.pathname.substr(sharedUrl.length);
        const resp = await ObterCredencialEletronicaCompartilhada({ chave });
        if (resp.Data !== undefined) {
          this.setSharedCredential(resp.Data[0]);
        } else if (resp.message) {
          this.error = resp.message;
        }
      } catch (error) {
        console.error(error);
        this.error = "Não foi possível obter a credencial";
      } finally {
        await this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>
